import { Injectable } from '@angular/core';
//import { MenuController, Events } from 'ionic-angular';
//import {Events} from '../../providers/eventService/events';
import { Events } from '../eventService/events';
import { Storage } from '@ionic/storage-angular';
import { FacharztAPIService } from '../../providers/api-handler/api-handler';
import { AccountManagerPatient } from '../../providers/account-manager/account-manager';
import { StorageManager } from '../../providers/storage-manager/storage-manager';
import { Observable, of, throwError } from 'rxjs';
import { AppSettings } from '../../app/appSettings';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { SearchResult, Appointement, Doctor, Practice, Networker, Employee, newEmployee, News, DoctorDetail, PatientEvent, PatientDashboardData } from '../../providers/content-provider/data-objects';
import { NotificationService } from '../notService/notification-handler';
import moment from 'moment';
//import { MapsAPILoader } from '@agm/core';
import { IAccountManager } from '../account-manager/IAccoung-manager';
import { catchError, map, switchMap, tap } from 'rxjs/operators';


@Injectable()
export class ContentProvider {
  search(searchbarText: string, zipValue: string, radValue: string, nameValue: string) {
    throw new Error('Method not implemented.');
  }
  getSpecs(): any[] | PromiseLike<any[]> {
    throw new Error('Method not implemented.');
  }
  DEBUG = AppSettings.DEBUG;
  TAG = "ContentProvider";
  api: FacharztAPIService;
  public accMngerPatient: AccountManagerPatient;
  accMnger: IAccountManager;
  storageMnger: StorageManager;

  instanceId: number = Math.random() * (99999 - 1) + 1;
  storageTableName: string = "kv";
  data: any = [];
  docApps: any = [];

  patientFuncs: boolean = true;

  constructor(
    public mhttp: HttpClient,
    //public menu: MenuController,
    public notiService: NotificationService,
    public events: Events,
    public storage: Storage,
    //public mapsAPILoader: MapsAPILoader
  ) {
    this.api = new FacharztAPIService(mhttp);
    this.storage.create();
    this.storageMnger = new StorageManager(this.storage);

    this.accMngerPatient = new AccountManagerPatient(
      this.api,
      this.storageMnger,
      this.events
    );
    this.registerListeners();

  }

  /*
    this.events.subscribe('user:created', (data: any) => {
      console.log('Welcome', data.user, 'at', data.time);
  });
  */

  registerListeners() {
    this.events.subscribe("login", () => {
      if (this.DEBUG) console.log("Patient logged in.");
      this.data = [];
      this.patientFuncs = true;
      this.storageMnger.storage
        .get("persistent_noti_token")
        .then((notitoken) => {
          if (notitoken != null) {
            this.saveNotificationToken(notitoken).subscribe((data) => { });
          }
        });
    });
    this.events.subscribe("loginDoc", () => {
      this.data = [];
      this.patientFuncs = false;
    });
  }

  geocodeAddress(address: string, zip: string, city: string) {
    let type = "geocode";
    let id = address + zip + city;
    id = id.replace(" ", "_");

    return Observable.create((observer) => {
      let fromDataStorage = this.getFromDataStorage(type, id);
      if (fromDataStorage) {
        observer.next(fromDataStorage);
      } else {
        this.storageMnger.getFromStorage(type, id).subscribe((data) => {
          if (data !== null) {
            observer.next(data);
            this.setData(type, id, data);
          }
        });
      }

      //check if expired and pull data from api if neccessary
      this.storageMnger.getExpiredFromStorage(type, id).subscribe((expired) => {
        /*
        if (expired.expired) {
          this.mapsAPILoader.load().then(() => {
            let geocoder = new google.maps.Geocoder();

            geocoder.geocode(
              { address: address + ",+" + zip + "+" + city },
              (results, status) => {
                if (status == google.maps.GeocoderStatus.OK) {
                  observer.next(results);
                  observer.complete();
                  this.setData(type, id, results);
                  this.storageMnger.set(type, id, JSON.stringify(results));
                } else {
                  console.log("Error - ", results, " & Status - ", status);
                  observer.next(null);
                  observer.complete();
                }
              }
            );
          });
        } else {*/
        observer.complete();
        /*
      }
      */
      });
    });
  }

  getDocsForStandort(standortId, force = false) {
    if (this.DEBUG)
      console.log(this.TAG, "getDocsForStandort", standortId, force);

    return this.api.getDocsForStandort(standortId);
  }

  // ins, start & sort can be undefined - standard values will be set
 /* getSearchResults(params, force = false) {
    if (this.DEBUG) console.log(this.TAG, "getSearchResults", params, force);

    let start = params.start;
    let ins = params.ins;

    this.storageMnger.set("persistent", "last_spec", params.spec);
    this.storageMnger.set("persistent", "last_specName", params.specName);
    this.storageMnger.set("persistent", "last_zip", params.zip);
    this.storageMnger.set("persistent", "last_rad", params.rad);
    this.storageMnger.set("persistent", "last_ins", params.ins);

    if (start === undefined) {
      start = moment().toDate();
    } else {
      start = moment(start);
      let now = moment();

      if (start < now) {
        start = now.toDate();
      } else {
        start = start.toDate();
      }
    }

    if (ins === undefined) {
      ins = AppSettings.INSURANCE_DEFAULT;
    }

    if (!params.hasOwnProperty("sort") || params.sort === undefined) {
      params.sort = AppSettings.SORT_OPTION_DEFAULT;
    }
    return this.api.searchDocsWithAppointements(
      +params.spec,
      params.zip,
      +params.rad,
      ins,
      start,
      +params.sort
    );
  }*/

   getSearchResults(params, force = false) {
    if (this.DEBUG) console.log(this.TAG, "getSearchResults", params, force);
   
   
    let ins = params.ins;
    let start = params.start;
  
    this.storageMnger.set("persistent", "last_spec", params.spec);
    this.storageMnger.set("persistent", "last_specName", params.specName);
    this.storageMnger.set("persistent", "last_zip", params.zip);
    this.storageMnger.set("persistent", "last_rad", params.rad);
    this.storageMnger.set("persistent", "last_ins", params.ins);
   
    
   
    
  
    if (ins === undefined) {
      ins = AppSettings.INSURANCE_DEFAULT;
    }
  
    if (!params.hasOwnProperty("sort") || params.sort === undefined) {
      params.sort = AppSettings.SORT_OPTION_DEFAULT;
    }
    
    return this.api.searchDocsWithAppointements(
      +params.spec,
      params.zip,
      +params.rad==0 ? 1 : +params.rad,
      ins,
      
      +params.sort,
     
    );
     
  }

  getUsedSpecs() {
    if (this.DEBUG) console.log(this.TAG, "getUsedSpecs");
    let type = "specs-used";

    return Observable.create((observer) => {
      let fromDataStorage = this.getFromDataStorage(type, 0);
      if (fromDataStorage) {
        observer.next(fromDataStorage);
      } else {
        this.storageMnger.getFromStorage(type, 0).subscribe((specs) => {
          if (specs !== null) {
            observer.next(specs);
            this.setData(type, 0, specs);
          }
        });
      }

      //check if expired and pull data from api if neccessary
      this.storageMnger.getExpiredFromStorage(type, 0).subscribe((expired) => {
        if(this.DEBUG)console.log('expired', expired.expired, expired);
        if (expired.expired) {
          this.usePublicApi(type, 0).subscribe(
            (specs) => {
              observer.next(specs);
              observer.complete();
            },
            (error) => {
              observer.error(error);
            }
          );
        } else {
          observer.complete();
        }
      });
    });
  }

  getTopSpecs() {
    if (this.DEBUG) console.log(this.TAG, "getTopSpecs");
    let type = "topspecs";

    return Observable.create((observer) => {
      //Prüfen, ob die Frist abgelaufen ist und ggf. Daten aus der API abrufen
          this.usePublicApi(type, 0).subscribe(
            (specs) => {
              observer.next(specs);
              observer.complete();
            },
            (error) => {
              observer.error(error);
            }
          );
      });
  }


  getAllSpecs() {
    if (this.DEBUG) console.log(this.TAG, "getAllSpecs");
    let type = "specs";

    return Observable.create((observer) => {
      let fromDataStorage = this.getFromDataStorage(type, 0);
      if (fromDataStorage) {
        observer.next(fromDataStorage);
      } else {
        this.storageMnger.getFromStorage(type, 0).subscribe((specs) => {
          if (specs !== null) {
            observer.next(specs);
            this.setData(type, 0, specs);
          }
        });
      }

      //check if expired and pull data from api if neccessary
      this.storageMnger.getExpiredFromStorage(type, 0).subscribe((expired) => {
        if (expired.expired) {
          this.usePublicApi(type, 0).subscribe(
            (specs) => {
              observer.next(specs);
              observer.complete();
            },
            (error) => {
              observer.error(error);
            }
          );
        } else {
          observer.complete();
        }
      });
    });
  }

  searchDocsByName(query: string): Observable<Array<SearchResult>> {
    if (this.DEBUG) console.log(this.TAG, "searchDocsByName", query);
    
    return this.api.searchDocs(query);
    
  }

  searchPraxisByName(query: string): Observable<Array<SearchResult>> {
    if (this.DEBUG) console.log(this.TAG, "searchPraxisByName", query);
    
    return this.api.searchPraxis(query);
  }

  /**(query: string): Observable<Array<ZipResults>>{
    if (this.DEBUG) console.log(this.TAG, "searchPraxisByName", query);
    return this.api.searchPLZ(query);
  }*/

  searchPlz(query: string): Observable<any> {
    return Observable.create((observer) => {
      this.api.searchPLZ(query).subscribe((data) => {
        observer.next(data);
        observer.complete();
      });
    });
  }

  getPatientData(
    type: string,
    force: boolean = true,
    params = null
  ): Observable<any> {
    if (this.DEBUG) console.log(this.TAG, "getPatientData", type, force);
    if (force) {
      return Observable.create((observer) => {
        this.getPatient().subscribe(
          (data) => {
            if (this.DEBUG)
              console.log(
                this.TAG,
                "getPatientData",
                type,
                "data from api",
                data
              );
            observer.next(data);
            observer.complete();
          },
          (error) => {
            observer.error(error);
          }
        );
      });
    } else {
      return Observable.create((observer) => {
        //get always from storage first
        this.storageMnger.getFromStorage(type, 0).subscribe((data) => {
          //push data from storage to stream
          if (this.DEBUG)
            console.log(
              this.TAG,
              "getPatientData",
              type,
              "data from storage",
              data
            );
          if (data !== null) {
            observer.next(data);
          }

          //check if expired and pull data from api if neccessary
          this.storageMnger
            .getExpiredFromStorage(type, 0)
            .subscribe((expired) => {
              if (expired.expired) {
                this.getPatient().subscribe(
                  (data) => {
                    if (this.DEBUG)
                      console.log(
                        this.TAG,
                        "getPatientData",
                        type,
                        "data from api",
                        data
                      );
                    observer.next(data);
                    observer.complete();
                  },
                  (error) => {
                    observer.error(error);
                  }
                );
              } else {
                if (this.DEBUG)
                  console.log(
                    this.TAG,
                    "getPatientData",
                    type,
                    "not fetching because not expired"
                  );

                observer.complete();
              }
            });
        });
      });
    }
  }

  setViewCardsReason(viewCards) {
    if(this.DEBUG)console.log("setViewCardsReason", viewCards);
    this.storageMnger.set('persistant', 'viewcards_reason', viewCards);
  }

  getViewCardsReason(): Observable<any> {
    return Observable.create((observer) => {
      this.storageMnger.getFromStorage('persistant', 'viewcards_reason').subscribe((data) => {
        if(this.DEBUG)console.log("getViewCardsReason", data);
        observer.next(data);
        observer.complete();
      },
        (error) => {
          observer.error(error);
        });
    })
  }


  setDocRoleStorage(role) {
    if(this.DEBUG)console.log("setDocRole", role);
    this.storageMnger.set('persistant', 'docrole', role);
  }

  getDocRoleStorage(): Observable<any> {
    return Observable.create((observer) => {
      this.storageMnger.getFromStorage('persistant', 'docrole').subscribe((data) => {
        if(this.DEBUG)console.log("getDocRole", data);
        observer.next(data);
        observer.complete();
      },
        (error) => {
          observer.error(error);
        });
    })
  }

  getMessages(force: boolean): Observable<any> {
    if (this.DEBUG) console.log(this.TAG, "getMessages");
    if (force) {
      return Observable.create((observer) => {
        this.accMngerPatient.getManagedAccounts().subscribe((accounts) => {
          this.storageMnger.removeMessages().then((result) => {
            for (var i = accounts.length - 1; i >= 0; i--) {
              this.accMngerPatient
                .refreshTokens(
                  accounts[i].access,
                  accounts[i].accessExp,
                  accounts[i].refresh
                )
                .subscribe((tokens) => {
                  let name = accounts[i].name;
                  this.api.getMessages(tokens.access_token, name).subscribe(
                    (messages) => {
                      if(this.DEBUG)console.log('api messages', messages);
                      observer.next(messages);
                      //save to storage
                      this.storageMnger.saveMessages(messages);
                    },
                    (error) => { }
                  );
                });
            }
          });
        });
      });
    } else {
      return Observable.create((observer) => {
        //get always from storage first
        this.storageMnger
          .getFromStorage("patient_messages", 0)
          .subscribe((messages) => {
            //push data from storage to stream
            if (messages !== null) {
              observer.next(messages);
            }
            this.accMngerPatient.getManagedAccounts().subscribe((accounts) => {
              this.storageMnger.removeMessages().then((result) => {
                for (var i = accounts.length - 1; i >= 0; i--) {
                  this.accMngerPatient
                    .refreshTokens(
                      accounts[i].access,
                      accounts[i].accessExp,
                      accounts[i].refresh
                    )
                    .subscribe((tokens) => {
                      let name = accounts[i].name;
                      this.api.getMessages(tokens.access_token, name).subscribe(
                        (messages) => {
                          observer.next(messages);
                          //save to storage
                          this.storageMnger.saveMessages(messages);
                        },
                        (error) => { }
                      );
                    });
                }
              });
            });
          });
      });
    }
  }



  bookAppointment(app: Appointement, patientData: any, ntoken) {
    let comment = "Zuweisertermin für: " + patientData.name + " " + patientData.surname + ", geb." + patientData.birthday + ", Anmerkung:" + patientData.msg;

    return Observable.create((observer) => {
      if (ntoken != undefined && ntoken != '') {
        this.api.bookAppointmentAPI(ntoken, app, patientData, comment).subscribe((data) => {
          observer.next(data);
          observer.complete();
        });
      }
    });
  }



  bookEvent(
    event: Appointement,
    symptoms: string,
    forId: number,
    forOtherName: string,
    forOtherLastName: string,
    forOtherBirthday: string,
    insKKNumber: string,
    insName: string,
    insNumber: string,
    insStatus: string,
    egkF,
    egkB,
    attachments,
    group,
    chain = 0,
    chainapps = ''
  ): Observable<any> {

    if (forId > 0) {
      let comment = symptoms;
      symptoms = "Anfrage für ";
      if (forId == 1) {
        symptoms += "Kind - ";
      } else {
        symptoms += "andere Person - ";
      }
      symptoms += "Name des Patienten: " + forOtherName + " " + forOtherLastName + " - Bemerkung: " + comment + " - ";
    }

    if (this.DEBUG)
      console.log(
        this.TAG,
        "bookEvent",
        event,
        symptoms,
        forId,
        forOtherName,
        forOtherLastName
      );

    return Observable.create((observer) => {
      this.accMngerPatient.getAccessToken().subscribe(
        (key) => {
          this.api
            .bookEvent(
              key,
              event,
              symptoms,
              forId,
              forOtherName,
              forOtherLastName,
              forOtherBirthday,
              insKKNumber,
              insName,
              insNumber,
              insStatus,
              egkF,
              egkB,
              attachments,
              group,
              chain,
              chainapps
            )
            .subscribe(
              (data) => {
                if (this.DEBUG)
                  console.log(this.TAG, "bookEvent", "data from api", data);
                observer.next(data);
                observer.complete();
              },
              (error) => {
                observer.error(error);
              }
            );
        },
        (error) => {
          observer.error(error);
        }
      );
    });
  }

  checkDependencies(eventId: number): Observable<any> {
    return Observable.create((observer) => {
      this.accMngerPatient.getAccessToken().subscribe(
        (key) => {
          this.api.checkDependencies(key, eventId).subscribe(
            (data) => {
              if (this.DEBUG)
                console.log(this.TAG, "checkDependencies", "data from api", data);
              observer.next(data);
              observer.complete();
            },
            (error) => {
              observer.error(error);
            }
          );
        },
        (error) => {
          observer.error(error);
        });
    });
  }

  setDependencies(dependencyIds: Array<any>): Observable<any> {
    return Observable.create((observer) => {
      this.accMngerPatient.getAccessToken().subscribe(
        (key) => {
          this.api.setDependencies(key, dependencyIds).subscribe(
            (data) => {
              if (this.DEBUG)
                console.log(this.TAG, "setDependencies", "data from api", data);
              observer.next(data);
              observer.complete();
            },
            (error) => {
              observer.error(error);
            }
          );
        },
        (error) => {
          observer.error(error);
        });
    });
  }

  blockAppointmentWithoutReason(start, doc, ntoken): Observable<any> {
    return Observable.create(observer => {
      if (ntoken != undefined && ntoken != '') {
        this.api.blockAppointmentWithoutReasonAPI(ntoken, start, doc).subscribe(
          (data) => {
            observer.next(data);
            observer.complete();
          },
          (error) => {
            observer.error(error);
          }
        );
      }
    });
  }

  checkMaxBookings(docId, reason, start): Observable<any> {
    return Observable.create(observer => {
      if (start != undefined) {
        this.api.checkMaxBookings(docId, reason, start).subscribe(data => {
          observer.next(data);
          observer.complete();
        }, error => {
          observer.error(error);
        });
      } else {
        return false
      }
    });
  }

  blockAppointment(appid, start, doc, reason): Observable<any> {
    return Observable.create(observer => {
      if (appid != undefined || start != undefined) {
        this.api.blockAppointment(appid, start, doc, reason).subscribe(data => {
          observer.next(data);
          observer.complete();
        }, error => {
          observer.error(error);
        });
      } else {
        return false
      }
    });
  }

  enterWaitinglist(doc, dateTo): Observable<any> {
    return Observable.create((observer) => {
      this.accMngerPatient.getAccessToken().subscribe(
        (key) => {
          this.api.enterWaitinglist(key, doc, dateTo).subscribe(
            (data) => {
              observer.next(data);
              observer.complete();
            },
            (error) => {
              observer.error(error);
            }
          );
        },
        (error) => {
          observer.error(error);
        }
      );
    });
  }

  deleteMessage(messageId: string): Observable<any> {
    if (this.DEBUG) console.log(this.TAG, "deleteMessage", messageId);
    return Observable.create((observer) => {
      this.accMngerPatient.getAccessToken().subscribe(
        (key) => {
          this.api.deleteMessage(key, messageId).subscribe(
            (data) => {
              if (this.DEBUG)
                console.log(this.TAG, "deleteMessage", "data from api", data);

              observer.next(data);
              observer.complete();
            },
            (error) => {
              observer.error(error);
            }
          );
        },
        (error) => {
          observer.error(error);
        }
      );
    });
  }

  readStatusMessage(messageId: string): Observable<any> {
    if (this.DEBUG) console.log(this.TAG, "readStatusMessage", messageId);
    return Observable.create((observer) => {
      this.accMngerPatient.getAccessToken().subscribe(
        (key) => {
          this.api.readStatusMessage(key, messageId).subscribe(
            (data) => {
              if (this.DEBUG)
                console.log(
                  this.TAG,
                  "readStatusMessage",
                  "data from api",
                  data
                );

              observer.next(data);
              observer.complete();
            },
            (error) => {
              observer.error(error);
            }
          );
        },
        (error) => {
          observer.error(error);
        }
      );
    });
  }

  saveNotificationToken(noti_token: string): Observable<any> {
    if (this.DEBUG) console.log(this.TAG, "saveNotificationToken", noti_token);
    return Observable.create((observer) => {
      let am = this.accMngerPatient;
      am.getManagedAccounts().subscribe((accounts) => {
        for (var i = accounts.length - 1; i >= 0; i--) {
          am.refreshTokens(
            accounts[i].access,
            accounts[i].accessExp,
            accounts[i].refresh
          ).subscribe((tokens) => {
            if (this.patientFuncs)
              this.accMngerPatient
                .addPatientToAccountManagement(accounts[i], tokens)
                .then((promise) => { });

            if (this.DEBUG)
              console.log(
                this.TAG,
                "saveNotificationToken 1",
                tokens.access_token,
                noti_token
              );

            this.api
              .saveNotificationToken(tokens.access_token, noti_token)
              .subscribe(
                (data) => {
                  if (this.DEBUG)
                    console.log(
                      this.TAG,
                      "saveNotificationToken 2",
                      "data from api",
                      data
                    );
                },
                (error) => { }
              );
          });
        }
        observer.next(true);
        observer.complete();

        //   }));
      });
    });
  }

  saveNotificationTokenLocally(noti_token: string) {
    if (this.DEBUG)
      console.log(this.TAG, "saveNotificationTokenLocally", noti_token);
    this.storageMnger.set("persistent", "noti_token", noti_token);
  }

  getRequestTextById(docId: number): Observable<any> {
    return Observable.create(observer => {
      this.usePublicApi("requestText", docId, null).subscribe(
        (data) => {
          observer.next(data);
          observer.complete();
        },
        (error) => {
          observer.error(error);
        }
      );
    });
  }

  getReasonById(reasonId: number): Observable<any> {
    return Observable.create(observer => {
      this.usePublicApi("reason", reasonId, null).subscribe(
        (data) => {
          observer.next(data);
          observer.complete();
        },
        (error) => {
          observer.error(error);
        }
      );
    });
  }

  getRequestSettingsById(docId: number): Observable<any> {
    return Observable.create(observer => {
      this.usePublicApi("requestSettings", docId, null).subscribe(
        (data) => {
          observer.next(data);
          observer.complete();
        },
        (error) => {
          observer.error(error);
        }
      );
    });
  }

  sendMedMsg(docId: number, pzn: Array<any>, names: Array<any>, message: string): Observable<any> {
    return Observable.create(observer => {
      this.accMngerPatient.getAccessToken().subscribe(key => {
        this.api.sendMedMsg(key, docId, pzn, names, message).subscribe(data => {
          observer.next(data);
          observer.complete();
        }, error => {
          observer.error(error);
        });
      }, error => {
        observer.error(error);
      });
    });
  }

  sendMessage(docId: number, type: number, message: string, med: Array<any>, pzn: Array<any>, practice: Array<any>, thirds, thirdsname, thirdssurname, thirdsbirth): Observable<any> {
    if (this.DEBUG) console.log(this.TAG, 'sendMessage', docId, message);
    if (this.DEBUG) console.log(this.TAG, 'THIRDS', thirds, thirdsname, thirdsbirth);
    return Observable.create(observer => {
      this.accMngerPatient.getAccessToken().subscribe(key => {
        this.api.sendMessage(key, docId, message, type, med, pzn, practice, thirds, thirdsname, thirdssurname, thirdsbirth).subscribe(data => {
          if (this.DEBUG) console.log(this.TAG, 'sendMessage', 'data from api', data);

          observer.next(data);
          observer.complete();
        }, error => {
          observer.error(error);
        });
      }, error => {
        observer.error(error);
      });
    });
  }

  sendContactMessage(subject: string, name: string, mail: string, telnumber: string, message: string): Observable<any> {
    if (this.DEBUG) console.log(this.TAG, 'contactMail', subject, name, mail, telnumber, message);

    return Observable.create(observer => {
      this.api.contact(subject, name, mail, telnumber, message).subscribe(data => {
        observer.next(data);
        observer.complete();
      }, error => {
        observer.error(error);
      });
    });
  }

  saveBMP(bmpdata: string, uid: string, page: number, pages: number): Observable<any> {
    if (this.DEBUG) console.log(this.TAG, 'saveBMP', bmpdata);
    return Observable.create(observer => {
      this.accMngerPatient.getAccessToken().subscribe(key => {
        this.api.saveBMP(key, bmpdata, uid, page, pages).subscribe(data => {
          if (this.DEBUG) console.log(this.TAG, 'saveBMP', 'data from api', data);

          observer.next(data);
          observer.complete();
        }, error => {
          observer.error(error);
        });
      }, error => {
        observer.error(error);
      });
    });
  }

  getBMPBySharePin(pin: string): Observable<any> {
    if (this.DEBUG) console.log(this.TAG, "getBMPBySharePin", pin);
    return Observable.create((observer) => {
      this.accMngerPatient.getAccessToken().subscribe(
        (key) => {
          this.api.getBMPBySharePin(key, pin).subscribe(
            (data) => {
              if (this.DEBUG)
                console.log(
                  this.TAG,
                  "getBMPBySharePin",
                  "data from api",
                  data
                );

              observer.next(data);
              observer.complete();
            },
            (error) => {
              observer.error(error);
            }
          );
        },
        (error) => {
          observer.error(error);
        }
      );
    });
  }

  checkMail(email: string, isDoc: string): Observable<any> {
    if(this.DEBUG)console.log("cp.checkMail isDoc: " + isDoc);
    if (this.DEBUG) console.log(this.TAG, "checkMail", email);
    return this.api.checkMail(email, isDoc);
  }

  changePatientMail(oldEmail: string, newEmail: string, password: string): Observable<{ success: boolean, message?: string }> {
    if (this.DEBUG) {
        console.log('ChangeMail called with:', oldEmail, newEmail, password);
    }

    // Setze isDoc auf '0' für Patienten
    const isDoc = '0';

    // Wir benötigen das AccessToken, um den API-Aufruf zu authentifizieren
    return this.accMngerPatient.getAccessToken().pipe(
        switchMap((token: string) => {
            if (this.DEBUG) {
                console.log('AccessToken:', token);
            }

            return this.api.changeMail(oldEmail, newEmail, password, token).pipe(
                map((response: any) => {
                    if (this.DEBUG) {
                        console.log('API Response for changeMail:', response);
                    }

                    // Erfolgsfall
                    if (response?.success === true) {
                        return { success: true };
                    }

                    // Fehlerfälle
                    if (response?.success === false) {
                        let errorMessage = '';
                        switch (response?.message) {
                            case 'Error: New email already exists':
                                errorMessage = 'Die neue E-Mail ist bereits vergeben.';
                                break;
                            case 'Error: Old email not found':
                                errorMessage = 'Die alte E-Mail-Adresse wurde nicht gefunden.';
                                break;
                            case 'Error: Invalid password':
                                errorMessage = 'Das eingegebene Passwort ist ungültig.';
                                break;
                            case 'Error: Passwords do not match':
                                errorMessage = 'Die Passworteingaben stimmen nicht überein.';
                                break;
                           
                        }
                        //console.log(errorMessage, "Welcher Case? ")
                        return { success: false, message: errorMessage };
                    }

                    return { success: false, message: response?.message };
                }),
                catchError(error => {
                    console.error('Fehler bei der Anfrage:', error);
                    return of({ success: false, message: 'Fehler bei der Anfrage.' });
                })
            );
        }),
        catchError(error => {
            console.error('Fehler beim Abrufen des AccessTokens:', error);
            return of({ success: false, message: 'Fehler beim Abrufen des AccessTokens.' });
        })
    );
}




 




  clearNotifications(): void {
    if (this.DEBUG) console.log(this.TAG, "clearNotifications");
    this.notiService.clearAllNotification();
  }


  cancelEvent(eventId: string, symptoms: string): Observable<any> {
    if (this.DEBUG) console.log(this.TAG, "cancelEvent", eventId, symptoms);
    return Observable.create((observer) => {
      this.accMngerPatient.getAccessToken().subscribe(
        (key) => {
          this.api.cancelEvent(key, eventId, symptoms).subscribe(
            (data) => {
              if (this.DEBUG)
                console.log(this.TAG, "cancelEvent", "data from api", data);
              this.notiService.clearNotification(eventId);
              observer.next(data);
              observer.complete();
            },
            (error) => {
              observer.error(error);
            }
          );
        },
        (error) => {
          observer.error(error);
        }
      );
    });
  }

  saveNotification(type: string, data: string): Observable<any> {
    if (this.DEBUG) console.log(this.TAG, "saveUserData", type, data);
    return Observable.create((observer) => {
      this.accMngerPatient.getAccessToken().subscribe(
        (key) => {
          this.api.saveNotification(key, type, data).subscribe(
            (data) => {
              observer.next(data);
              observer.complete();
            },
            (error) => {
              observer.error(error);
            }
          );
        },
        (error) => {
          observer.error(error);
        }
      );
    });
  }

  loadNotification(): Observable<any> {
    return Observable.create((observer) => {
      this.accMngerPatient.getAccessToken().subscribe(
        (key) => {
          this.api.loadNotification(key).subscribe(
            (data) => {
              observer.next(data);
              observer.complete();
            },
            (error) => {
              observer.error(error);
            }
          );
        },
        (error) => {
          observer.error(error);
        }
      );
    });
  }

  saveUserData(type: string, data: string): Observable<any> {
    if (this.DEBUG) console.log(this.TAG, "saveUserData", type, data);
    return Observable.create((observer) => {
      this.accMngerPatient.getAccessToken().subscribe(
        (key) => {
          this.api.saveUserData(key, type, data).subscribe(
            (data) => {
              observer.next(data);
              observer.complete();
            },
            (error) => {
              observer.error(error);
            }
          );
        },
        (error) => {
          observer.error(error);
        }
      );
    });
  }

/*   handleError(error: any): any {
    // In a real world app, we might use a remote logging infrastructure
    // We'd also dig deeper into the error to get a better message
    if(this.DEBUG)console.log(error);
    let errMsg = error.message
      ? error.message
      : error.status
        ? "${error.status} - ${error.statusText}"
        : "Server error";

    console.error(errMsg); // log to console instead
    return Observable.throw(errMsg);
  } */
// new Register 
    registerPatient(
      anr: string,
      vorname: string,
      nachname: string,
      birthday: string,
      tel: string,
      email: string,
      password: string,
      agb: string,
      country: string
    ): Observable<any> {
      if (this.DEBUG)
        console.log(
          this.TAG,
          "registerPatient",
          anr,
          vorname,
          nachname,
          birthday,
          tel,
          email,
          password,
          agb,
          country
        );
    
      return Observable.create((observer) => {
        this.api
          .register(
            anr,
            vorname,
            nachname,
            birthday,
            tel,
            email,
            password,
            agb,
            country
          )
          .subscribe(
            (data) => {
              // Hier den Hash aus der Antwort extrahieren
              const hash = data.hash;  // Der Hash-Wert wird hier extrahiert
    
              if (this.DEBUG) {
                console.log('Received Hash:', hash);
              }
    
              // Optional: Den Hash im lokalen Speicher oder in einer Service-Variable speichern
              this.storageMnger.set("persistent", "last_hash", hash);
    
              observer.next(data);
              observer.complete();
    
              // Optional: Speichern der E-Mail und anderer Daten in persistentem Speicher
              this.storageMnger.set("persistent", "last_email", email);
    
              // Beispiel: Speicherung des Tokens, falls es vom Server zurückgegeben wird
              // this.saveTokensInStorage(data);
            },
            (error) => {
              observer.error(error);
            }
          );
      });
    }
    //end new Register

  getDocRequests(docid): Observable<any> {
    return Observable.create((observer) => {
      this.api.getDocRequests(docid)
        .subscribe(
          (data) => {
            observer.next(data);
            observer.complete();
          },
          (error) => {
            observer.error(error);
          }
        );
    });
  }

  registerDoctor(
    anr: string,
    vorname: string,
    nachname: string,
    title: string,
    street: string,
    plz: string,
    city: string,
    spec: string,

    praxis: string,
    pstreet: string,
    pplz: string,
    pcity: string,

    mobile: string,
    tel: string,

    email: string,
    password: string,
    agb: string
  ): Observable<any> {
    if (this.DEBUG)
      console.log(
        this.TAG,
        "registerDoctor",
        anr,
        vorname,
        nachname,
        street,
        city,
        plz,
        title,
        praxis,
        spec,
        mobile,
        tel,
        pstreet,
        pplz,
        pcity,
        email,
        password,
        agb
      );
    return Observable.create((observer) => {
      this.api
        .registerDoctor(
          anr,
          vorname,
          nachname,
          title,
          street,
          plz,
          city,
          spec,
          praxis,
          pstreet,
          pplz,
          pcity,
          mobile,
          tel,
          email,
          password,
          agb
        )
        .subscribe(
          (data) => {
            observer.next(data);
            // this.menu.enable(true, 'menu-logged-in');
            // this.menu.enable(false, 'menu-logged-out');
            observer.complete();
            this.storageMnger.set("persistent", "last_email", email);
            //store tokens in local storage
            // this.saveTokensInStorage(data);
          },
          (error) => {
            observer.error(error);
          }
        );
    });
  }

  registerNetworker(id, pw): Observable<any> {
    return Observable.create((observer) => {
      this.api.registerNetworker(id, pw)
        .subscribe(
          (data) => {
            observer.next(data);
            observer.complete();
          },
          (error) => {
            observer.error(error);
          }
        );
    });
  }

  getNetworkerByHash(hash: string): Observable<any> {
    return Observable.create((observer) => {
      this.api.getNetworkerByHash(hash)
        .subscribe(
          (data) => {
            observer.next(data);
            observer.complete();
          },
          (error) => {
            observer.error(error);
          }
        );
    });
  }

  getDocOpenApps(
    id: number,
    start: Date,
    end: Date,
    force: boolean = false,
    insurance: number = AppSettings.INSURANCE_DEFAULT,
    reason: number = 0
  ): Observable<Appointement[]> {
    if (this.DEBUG)
      console.log(this.TAG, "getDocOpenApps", id, start, end, insurance, force);

    moment(start).startOf("second").toDate();
    moment(end).startOf("second").toDate();
    let type = "doc_open_apps";
    let params = [insurance, start, end, reason];
    let storageId = this.getIdForStorage(id, params);

    if (force) {
      return this.usePublicApi(type, id, params);
    } else {
      return Observable.create((observer) => {
        let data = this.getDocApps(type, storageId);
        if (data) {
          observer.next(JSON.parse(data));
        } else {
          this.usePublicApi(type, id, params).subscribe(
            (data) => {
              observer.next(data);
              observer.complete();
            },
            (error) => {
              observer.error(error);
            }
          );
        }
      });
    }
  }

  saveDocApps(type, id, data): void {
    this.docApps[type + "_" + id] = data;
    if (this.DEBUG) console.log(this.TAG, "saveDocApps", this.data);
  }

  //Todo update solution

 /*  getPackagesByDoc( docid ): Observable<any> {
    return Observable.create((observer) => {
      this.api.getPackagesByDoc(docid)
        .subscribe(
          (data) => {
            observer.next(data);
            observer.complete();
          },
          (error) => {
            observer.error(error);
          }
        );
    });
  } */

  getDocApps(type, id): any {
    let arrayKey: string = type + "_" + id;
    if (
      this.docApps[arrayKey] !== undefined &&
      this.docApps[arrayKey] !== null
    ) {
      return this.docApps[arrayKey];
    } else {
      return false;
    }
  }

  clearDocApps(): void {
    this.docApps = [];
  }

  getMorePatientAppHistory(
    offset: number,
    limit: number
  ): Observable<Array<Appointement>> {
    return Observable.create((observer) => {
      this.accMngerPatient.getAccessToken().subscribe(
        (key) => {
          if (key !== null) {
            this.api.getPatientAppHistory(key, offset, limit).subscribe(
              (appsHist) => {
                observer.next(appsHist);
                observer.complete();
              },
              (error) => {
                observer.error(error);
              }
            );
          } else {
            if (this.DEBUG)
              console.log(
                this.TAG,
                "usePrivateApi",
                "no access token received"
              );
          }
        },
        (error) => {
          observer.error(error);
        }
      );
    })
  }

  //get data from public api/storage
  //type (string): doc, praxis, search_results, ...
  //id (int): id of doc, patient, ...
  //force will not seach in storage and will force an api request
  getByID(
    type: string,
    id: number = 0,
    force: boolean = false
  ): Observable<any> {
    if (this.DEBUG) console.log(this.TAG, "getByID", type, id, force);
    // console.log(this.data);
    if (force) {
      return this.usePublicApi(type, id);
    } else {
      return Observable.create((observer) => {
        let fromDataStorage = this.getFromDataStorage(type, id);
        if (fromDataStorage) {
          observer.next(fromDataStorage);
        } else {
          this.storageMnger.getFromStorage(type, id).subscribe((data) => {
            if (data !== null) {
              observer.next(data);
              this.setData(type, id, data);
            }
          });
        }
        this.storageMnger
          .getExpiredFromStorage(type, id)
          .subscribe((expired) => {
            if (expired.expired) {
              this.usePublicApi(type, id).subscribe(
                (data) => {
                  observer.next(data);
                  observer.complete();
                },
                (error) => {
                  observer.error(error);
                }
              );
            }
          });
      });
    }
  }

  getBarcode(
    currentBmpPages: Array<any>,
    force: boolean = false
  ): Observable<any> {
    if (this.DEBUG) console.log(this.TAG, "getBarcode", currentBmpPages);

    if (force) {
      return this.usePrivateApi("patient_bmp_barcode");
    } else {
      return Observable.create((observer) => {
        // 1. try to get from data storage if barcode has content of current bmop
        // 2. try to get from local storage if barcode has content of current bmop
        // 3. get current barcode from api
        let storedBarcodes = this.getFromDataStorage("patient_bmp_barcode", 0);
        if (
          storedBarcodes &&
          !this.isExpiredBarcode(currentBmpPages, storedBarcodes)
        ) {
          observer.next(storedBarcodes);
        } else {
          this.storageMnger.getFromStorage("patient_bmp_barcode", 0).subscribe(
            (data) => {
              if (
                data !== null &&
                !this.isExpiredBarcode(currentBmpPages, data)
              ) {
                observer.next(data);
                observer.complete();
                this.setData("patient_bmp_barcode", 0, data);
              } else {
                this.usePrivateApi("patient_bmp_barcode").subscribe(
                  (apiData) => {
                    observer.next(apiData);
                    observer.complete();
                  },
                  (error) => {
                    observer.error(error);
                  }
                );
              }
            },
            (error) => {
              observer.error(error);
            }
          );
        }
      });
    }
  }

  isExpiredBarcode(bmpData, barcodeData): boolean {
    // check if stored barcodes are expired, because hashes are not the same for all pages
    let expired: boolean = false;
    if (bmpData && barcodeData) {
      for (let bmpPage in bmpData) {
        for (let barcode in barcodeData) {
          if (
            bmpPage.hasOwnProperty("page") &&
            bmpPage.hasOwnProperty("hash") &&
            barcode.hasOwnProperty("page") &&
            barcode.hasOwnProperty("hash")
          ) {
            if (
              barcode["page"] === bmpPage["page"] &&
              bmpPage["hash"] !== barcode["hash"]
            ) {
              expired = true;
            }
          } else {
            expired = true;
          }
        }
      }
    }
    if (this.DEBUG)
      console.log(this.TAG, "isExpiredBarcode", bmpData, barcodeData, expired);
    return expired;
  }



  getBMP(): Observable<any> {
    return new Observable((observer) => {
      this.accMngerPatient.getAccessToken().subscribe(
        (key) => {
          this.api.getBMP(key).subscribe(
            (bmp) => {
              observer.next(bmp);
              observer.complete();
              //save to storage
              this.storageMnger.set(
                "patient_bmp",
                0,
                JSON.stringify(bmp)
              );
            },
            (error) => {
              observer.error(error);
            }
          );
        },
        (error) => {
          observer.error(error);
        }
      );
    });
  }



  getAllBMPs(): Observable<any> {
    return new Observable((observer) => {
      this.accMngerPatient.getAccessToken().subscribe(
        (key) => {
          this.api.getAllBMPs(key).subscribe(
            (bmp) => {
              observer.next(bmp);
              observer.complete();
            },
            (error) => {
              observer.error(error);
            }
          );
        },
        (error) => {
          observer.error(error);
        }
      );
    });
  }

  getPatient(): Observable<any> {
    return new Observable((observer) => {
      this.accMngerPatient.getAccessToken().subscribe(
        (key) => {
          this.api.getPatient(key).subscribe(
            (patient) => {
              if(this.DEBUG)console.log('PATIENT', patient);
              observer.next(patient);
              observer.complete();
              //save to storage
              this.storageMnger.set(
                "patient",
                0,
                JSON.stringify(patient)
              );
            },
            (error) => {
              observer.error(error);
            }
          );
        },
        (error) => {
          observer.error(error);
        }
      );
    });
  }

  getPatientAppsbyDoc(params): Observable<any> {
    return new Observable((observer) => {
      this.accMngerPatient.getAccessToken().subscribe(
        (key) => {
          this.api.getPatientAppsbyDoc(key, params).subscribe(quarterApps => {
            observer.next(quarterApps);
            observer.complete();
            //save to storage

          }, error => {
            observer.error(error);
          });
        },
        (error) => {
          observer.error(error);
        }
      );
    });
  }

  getPatientAppHistory(): Observable<any> {
    return new Observable((observer) => {
      this.accMngerPatient.getAccessToken().subscribe(
        (key) => {
          this.api.getPatientAppHistory(key).subscribe(
            (appsHist) => {
              observer.next(appsHist);
              observer.complete();
              //save to storage
              this.storageMnger.set(
                "patient_history",
                0,
                JSON.stringify(appsHist)
              );
            },
            (error) => {
              observer.error(error);
            }
          );
        },
        (error) => {
          observer.error(error);
        }
      );
    });
  }



  getPatientOpenApps(): Observable<any> {
    return new Observable((observer) => {
      this.accMngerPatient.getAccessToken().subscribe(
        (key) => {
          this.api.getPatientOpenApps(key).subscribe(
            (openApps) => {
              if(this.DEBUG)console.log('ContentProvider OPENAPPS', openApps);
              observer.next(openApps);
              observer.complete();
              //this.notiService.setupNotifications(openApps);
              this.storageMnger
                .getFromStorage("persistent", "notifications")
                .subscribe((data) => {


                  if (data === null || data == true) {
                    this.notiService.setupNotifications(openApps);
                  }
                });
              //save to storage
              this.storageMnger.set(
                "patient_open_apps",
                0,
                JSON.stringify(openApps)
              );
            },
            (error) => {
              observer.error(error);
            }
          );
        },
        (error) => {
          observer.error(error);
        }
      );
    });
  }

  getPatientFrequentDocs(): Observable<any> {
    return new Observable((observer) => {
      this.accMngerPatient.getAccessToken().subscribe(
        (key) => {
          this.api.getPatientFrequentDocs(key).subscribe(
            (freqDocs) => {
              if(this.DEBUG)console.log('getpatientfrequentdocs', freqDocs);
              observer.next(freqDocs);
              observer.complete();
              //save to storage
              this.storageMnger.set(
                "patient_freq_docs",
                0,
                JSON.stringify(freqDocs)
              );
            },
            (error) => {
              observer.error(error);
            }
          );
        },
        (error) => {
          observer.error(error);
        }
      );
    });
  }




  //use ApiHandler to connect to API
  usePrivateApi(type: string, params = null): Observable<any> {
    if (this.DEBUG) console.log(this.TAG, "usePrivateApi", type, params);
    //Todo update umbauen ohne Observable create catch

    return Observable.create((observer) => {
      this.accMngerPatient.getAccessToken().subscribe(
        (key) => {
          if (key !== null) {
            //call to ApiHandler
            switch (type) {
              /*  case "patient":
                 this.api.getPatient(key).subscribe(
                   (patient) => {
                     observer.next(patient);
                     observer.complete();
                     //save to storage
                     this.storageMnger.set(
                       "patient",
                       0,
                       JSON.stringify(patient)
                     );
                   },
                   (error) => {
                     observer.error(error);
                   }
                 );
                 break; */
              case "patient_history":
                this.api.getPatientAppHistory(key).subscribe(
                  (appsHist) => {
                    observer.next(appsHist);
                    observer.complete();
                    //save to storage
                    this.storageMnger.set(
                      "patient_history",
                      0,
                      JSON.stringify(appsHist)
                    );
                  },
                  (error) => {
                    observer.error(error);
                  }
                );
                break;
              /*       case "patient_quarter_apps":
                      this.api.getPatientAppsbyDoc(key, params).subscribe(quarterApps => {
                          observer.next(quarterApps);
                          observer.complete();
                          //save to storage
                          this.storageMnger.set('patient_history', 0, JSON.stringify(quarterApps));
                      }, error => {
                          observer.error(error);
                      });
                      break; */
              case "bmp_share":
                this.api.getBMPSharePin(key).subscribe(
                  (pin) => {
                    observer.next(pin);
                    observer.complete();
                    //save to storage
                  },
                  (error) => {
                    observer.error(error);
                  }
                );
                break;
              /*     case "patient_bmp":
                    this.api.getBMP(key).subscribe(
                      (bmp) => {
                        observer.next(bmp);
                        observer.complete();
                        //save to storage
                        this.storageMnger.set(
                          "patient_bmp",
                          0,
                          JSON.stringify(bmp)
                        );
                      },
                      (error) => {
                        observer.error(error);
                      }
                    );
                    break; */
              case "patient_bmp_barcode":
                this.api.getBarcode(key).subscribe(
                  (barcode) => {
                    observer.next(barcode);
                    observer.complete();
                    //save to storage
                    this.setData("patient_bmp_barcode", 0, barcode);
                    this.storageMnger.set(
                      "patient_bmp_barcode",
                      0,
                      JSON.stringify(barcode)
                    );
                  },
                  (error) => {
                    observer.error(error);
                  }
                );
                break;
              /*    case "patient_freq_docs":
                   this.api.getPatientFrequentDocs(key).subscribe(
                     (freqDocs) => {
                       observer.next(freqDocs);
                       observer.complete();
                       //save to storage
                       this.storageMnger.set(
                         "patient_freq_docs",
                         0,
                         JSON.stringify(freqDocs)
                       );
                     },
                     (error) => {
                       observer.error(error);
                     }
                   );
                   break; */
              /*  case "patient_open_apps":
                 this.api.getPatientOpenApps(key).subscribe(
                   (openApps) => {
                     observer.next(openApps);
                     observer.complete();
                     this.storageMnger
                       .getFromStorage("persistent", "notifications")
                       .subscribe((data) => {
                         if (data === null || data == true) {
                           //this.notiService.setupNotifications(openApps);
                         }
                       });
                     //save to storage
                     this.storageMnger.set(
                       "patient_open_apps",
                       0,
                       JSON.stringify(openApps)
                     );
                   },
                   (error) => {
                     observer.error(error);
                   }
                 );
                 break; */
              default:
                return null;
            }
          } else {
            if (this.DEBUG)
              console.log(
                this.TAG,
                "usePrivateApi",
                "no access token received"
              );
          }
        },
        (error) => {
          observer.error(error);
        }
      );
    }).catch((e) => {
      if (e.status == 401 || e.message == "no refresh token") {
        if (this.DEBUG) console.log(this.TAG, "no permission", "logging out");
        this.accMngerPatient.logout().subscribe((message) => {
          if(this.DEBUG)console.log("logout: " + message);
        });
        return Observable.create(() => { });
      } else {
        return throwError(e)
        //return Observable.throw(e);
      }
    });
  }

  usePublicApi(type: string, id: number, params = null): Observable<any> {
    if (this.DEBUG) console.log(this.TAG, "usePublicApi", type, id, params);

    return Observable.create((observer) => {
      switch (type) {
        case "doc":
          this.api.getDoctor(id).subscribe(
            (data) => {
              if (this.DEBUG) console.log(this.TAG, "usePublicApi data", data);

              observer.next(data);
              observer.complete();
              //Daten im lokalen Speicher speichern
              this.setData(type, id, data);
              this.storageMnger.set(type, id, JSON.stringify(data));
            },
            (error) => {
              observer.error(error);
            }
          );
          break;
        case "event":
          this.api.getOpenAppointement(id).subscribe(
            (data) => {
              observer.next(data);
              observer.complete();
              //Daten im lokalen Speicher speichernge
              this.setData(type, id, data);
              this.storageMnger.set(type, id, JSON.stringify(data));
            },
            (error) => {
              observer.error(error);
            }
          );
          break;
        case "praxis":
          this.api.getPractice(id).subscribe(
            (data) => {
              observer.next(data);
              observer.complete();
              //Daten im lokalen Speicher speichern
              this.setData(type, id, data);
              this.storageMnger.set(type, id, JSON.stringify(data));
            },
            (error) => {
              observer.error(error);
            }
          );
          break;
        case "doc_open_apps":
          this.api
            .geDocOpenEvents(id, params[0], params[1], params[2], params[3])
            .subscribe(
              (data) => {
                if(this.DEBUG)console.log('Apps in DocPage Content Provider', data);

                observer.next(data);
                observer.complete();
                //store data in runtime storage
                let storageId = this.getIdForStorage(id, params);
                this.saveDocApps(type, storageId, JSON.stringify(data));
              },
              (error) => {
                observer.error(error);
              }
            );
          break;
        case "specs":
          this.api.getAllSpecs().subscribe(
            (data) => {
              observer.next(data);
              observer.complete();
              //store data in local storage
              this.setData(type, id, data);
              this.storageMnger.set(type, id, JSON.stringify(data));
            },
            (error) => {
              observer.error(error);
            }
          );
          break;
        case "specs-used":
          this.api.getUsedSpecs().subscribe(
            (data) => {
              observer.next(data);
              observer.complete();
              //store data in local storage
              this.setData(type, id, data);
              this.storageMnger.set(type, id, JSON.stringify(data));
            },
            (error) => {
              observer.error(error);
            }
          );
          break;
          case "topspecs":
          this.api.getTopSpecs().subscribe(
            (data) => {
              observer.next(data);
              observer.complete();
              //Daten im lokalen Speicher speichern
              this.setData(type, id, data);
              this.storageMnger.set(type, id, JSON.stringify(data));
            },
            (error) => {
              observer.error(error);
            }
          );
          break;
        case "med":
          this.api.getMed(id).subscribe(
            (data) => {
              if(this.DEBUG)console.log(data);
              observer.next(data);
              observer.complete();
              //store data in local storage
              this.setData(type, id, data);
              this.storageMnger.set(type, id, JSON.stringify(data));
            },
            (error) => {
              observer.error(error);
            }
          );
          break;
        case "app":
          this.api.getApp(id).subscribe(
            (data) => {
              observer.next(data);
              observer.complete();
              //store data in local storage
              this.setData(type, id, data);
              this.storageMnger.set(type, id, JSON.stringify(data));
            },
            (error) => {
              observer.error(error);
            }
          );
          break;
        case "impressum":
          this.api.getImprint(id).subscribe(
            (data) => {
              observer.next(data);
              observer.complete();
              //store data in local storage
              this.setData(type, id, data);
              this.storageMnger.set(type, id, JSON.stringify(data));
            },
            (error) => {
              observer.error(error);
            }
          );
          break;
        case "reason":
          this.api.getReasonData(id).subscribe(data => {
            observer.next(data);
            observer.complete();
            //store data in local storage
            this.setData(type, id, data);
            this.storageMnger.set(type, id, JSON.stringify(data));
          }, error => {
            observer.error(error);
          });
          break;
        case "reasonAdditionals":
          this.api.getReasonAdditionalsAPI(id).subscribe(data => {
            observer.next(data);
            observer.complete();
            //store data in local storage
            this.setData(type, id, data);
            this.storageMnger.set(type, id, JSON.stringify(data));
          }, error => {
            observer.error(error);
          });
          break;
        case "requestSettings":
          this.api.getDocRequests(id).subscribe(data => {
            observer.next(data);
            observer.complete();
            //store data in local storage
            this.setData(type, id, data);
            this.storageMnger.set(type, id, JSON.stringify(data));
          }, error => {
            observer.error(error);
          });
          break;
        case "urlaubsingle":
          this.api.getUrlaubByDocId(id).subscribe(data => {
            observer.next(data);
            observer.complete();
            //store data in local storage
            this.setData(type, id, data);
            this.storageMnger.set(type, id, JSON.stringify(data));
          }, error => {
            observer.error(error);
          });
          break;
        case "practiceurlaub":
          this.api.getPracticeurlaub(id).subscribe(data => {
            observer.next(data);
            observer.complete();
            //store data in local storage
            this.setData(type, id, data);
            this.storageMnger.set(type, id, JSON.stringify(data));
          }, error => {
            observer.error(error);
          });
          break;
        case "publicholidaydocdate":
          this.api.getHolidayListbyDocDate(id).subscribe(data => {
            observer.next(data);
            observer.complete();
            //store data in local storage
            this.setData(type, id, data);
            this.storageMnger.set(type, id, JSON.stringify(data));
          }, error => {
            observer.error(error);
          });
          break;
        case "requestText":
          this.api.getRequestTextById(id).subscribe(data => {
            observer.next(data);
            observer.complete();
            //store data in local storage
            this.setData(type, id, data);
            this.storageMnger.set(type, id, JSON.stringify(data));
          }, error => {
            observer.error(error);
          });
          break;
        default:
          break;
      }
    });
  }

  getFromDataStorage(type, id): any {
    let arrayKey: string = type + "_" + id;
    if (this.data[arrayKey] !== undefined && this.data[arrayKey] !== null) {
      return this.data[arrayKey];
    } else {
      return false;
    }
  }

  getPackagesByDoc( docid ): Observable<any> {
    return Observable.create((observer) => {
      this.api.getPackagesByDoc(docid)
        .subscribe(
          (data) => {
            observer.next(data);
            observer.complete();
          },
          (error) => {
            observer.error(error);
          }
        );
    });
  }

  setData(type, id, data): void {
    this.data[type + "_" + id] = data;
    if (this.DEBUG) console.log(this.TAG, "setData", this.data);
  }

  getIdForStorage(id: number, params: Array<any>): string {
    let _id = [String(id)];
    for (let param of params) {
      _id.push(String(param));
    }
    return _id.join("_");
  }

  //retunr current timestamp in seconds
  getCurTS(): number {
    return moment().unix();
  }

  //generate random 5 character string
  generateId(): string {
    var text = "";
    var possible =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    for (var i = 0; i < 5; i++) {
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    }
    return text;
  }

  setMaintainance(id: number, endTS: number, seen: boolean = true) {
    this.storage.set("Maintainance", { seen: seen, end: endTS });
  }

  async showMaintainance(): Promise<any> {
    return this.storage.get("Maintainance");
  }


  /*
   * DOC API
   */
  getDocData(token = ''): Observable<Doctor> {
    return Observable.create((observer) => {
      if (token !== '') {
        this.api.getDocData(token).subscribe((data) => {
          this.api.getSubDocs(token).subscribe((docs) => {
            let doctors = [];
            doctors.push(data);
            docs.forEach((doc) => doctors.push(doc));
            observer.next(doctors);
            observer.complete();
          });
        });
      }
    });
  }

  checkikvnr(ik: string): Observable<any> {
    if (this.DEBUG) console.log(this.TAG, "checkikvnr", ik);
    return this.api.checkikvnr(ik);
  }


  getDocOpenAppsByIdAPI(id, start, end): Observable<any> {
    return Observable.create((observer) => {
      this.api.getDocOpenAppsByIdAPI(id, start, end).subscribe((data) => {
        observer.next(data);
        observer.complete();
      });
    });
  }



  getNetworkDocsByToken(token): Observable<any> {
    return Observable.create((observer) => {
      this.api
        .getNetworkDocsByToken(token)
        .subscribe((data) => {
          observer.next(data);
          observer.complete();
        });
    });
  }

  getNetworkPatientData(token): Observable<any> {
    return Observable.create((observer) => {
      this.api
        .getNetworkPatientData(token)
        .subscribe((data) => {
          observer.next(data);
          observer.complete();
        });
    });
  }


  getWaitinglist(docId): Observable<any> {
    return Observable.create((observer) => {
      this.accMngerPatient.getAccessToken().subscribe(
        (key) => {
          this.api.getWaitinglist(key, docId).subscribe(
            (data) => {
              observer.next(data);
              observer.complete();
            },
            (error) => {
              observer.error(error);
            }
          );
        },
        (error) => {
          observer.error(error);
        }
      );
    });
  }

  getReasonAdditionalsAPI(reasonId): Observable<any> {
    return Observable.create((observer) => {
      this.accMngerPatient.getAccessToken().subscribe(
        (key) => {
          this.api.getReasonAdditionals(key, reasonId).subscribe(
            (data) => {
              observer.next(data);
              observer.complete();
            },
            (error) => {
              observer.error(error);
            }
          );
        },
        (error) => {
          observer.error(error);
        }
      );
    });
  }

  getFavoriteDoctors(): Observable<any> {
    return Observable.create((observer) => {
      this.accMngerPatient.getAccessToken().subscribe(
        (key) => {
          this.api.getFavoriteDoctors(key).subscribe(
            (data) => {
              observer.next(data);
              observer.complete();
            },
            (error) => {
              observer.error(error);
            }
          );
        },
        (error) => {
          observer.error(error);
        }
      );
    });
  }


  deleteFavoriteDoctors(id): Observable<any> {
    if(this.DEBUG)console.log(this.TAG, "cp request", id);
    return Observable.create((observer) => {
      this.accMngerPatient.getAccessToken().subscribe(
        (key) => {
          this.api.deleteFavoriteDoctors(key, id).subscribe(
            (data) => {
              observer.next(data);
              observer.complete();
            },
            (error) => {
              observer.error(error);
            }
          );
        },
        (error) => {
          observer.error(error);
        }
      );
    });
  }

  insertFavoriteDoctors(doctor): Observable<any> {
    return Observable.create((observer) => {
      this.accMngerPatient.getAccessToken().subscribe(
        (key) => {
          if(this.DEBUG)console.log('FAV in cp', key);

          this.api.insertFavoriteDoctors(key, doctor).subscribe(
            (data) => {
              observer.next(data);
              observer.complete();
            },
            (error) => {
              observer.error(error);
            }
          );
        },
        (error) => {
          console.log('FAV in cp', error);

          observer.error(error);
        }
      );
    });
  }


  /*--------------------------------------------ENDE FAVORITE DOCTORS----------------------*/


  //Todo medslist

  getMedList(): Observable<any> {
    return Observable.create((observer) => {
      this.accMngerPatient.getAccessToken().subscribe(
        (key) => {
          this.api.getMedList(key).subscribe(
            (data) => {
              observer.next(data);
              observer.complete();
            },
            (error) => {
              observer.error(error);
            }
          );
        },
        (error) => {
          observer.error(error);
        }
      );
    });
  }

  saveMedListPat(data): Observable<any> {
    return Observable.create((observer) => {
      this.accMngerPatient.getAccessToken().subscribe(
        (key) => {
          this.api.saveMedListPat(key, data).subscribe(
            (data) => {
              observer.next(data);
              observer.complete();
            },
            (error) => {
              observer.error(error);
            }
          );
        },
        (error) => {
          observer.error(error);
        }
      );
    });
  }


  activateMedListPat(activ): Observable<any> {
    return Observable.create((observer) => {
      this.accMngerPatient.getAccessToken().subscribe(
        (key) => {
          this.api.activateMedListPat(key, activ).subscribe(
            (data) => {
              observer.next(data);
              observer.complete();
            },
            (error) => {
              observer.error(error);
            }
          );
        },
        (error) => {
          observer.error(error);
        }
      );
    });
  }


  deactivateMedListPat(): Observable<any> {
    return Observable.create((observer) => {
      this.accMngerPatient.getAccessToken().subscribe(
        (key) => {
          this.api.deactivateMedListPat(key).subscribe(
            (data) => {
              observer.next(data);
              observer.complete();
            },
            (error) => {
              observer.error(error);
            }
          );
        },
        (error) => {
          observer.error(error);
        }
      );
    });
  }

  checkBMPList(bmpid): Observable<any> {
    return Observable.create((observer) => {
      this.accMngerPatient.getAccessToken().subscribe(
        (key) => {
          this.api.checkBMPList(key, bmpid).subscribe(
            (data) => {
              observer.next(data);
              observer.complete();
            },
            (error) => {
              observer.error(error);
            }
          );
        },
        (error) => {
          observer.error(error);
        }
      );
    });
  }

  setBMPList(bmpid): Observable<any> {
    return Observable.create((observer) => {
      this.accMngerPatient.getAccessToken().subscribe(
        (key) => {
          this.api.setBMPList(key, bmpid).subscribe(
            (data) => {
              observer.next(data);
              observer.complete();
            },
            (error) => {
              observer.error(error);
            }
          );
        },
        (error) => {
          observer.error(error);
        }
      );
    });
  }


  getWidget(docId, time, color): Observable<any> {
    return Observable.create((observer) => {
      this.api.getWidget(docId, time, color).subscribe(
        (data) => {
          observer.next(data);
          observer.complete();
        },
        (error) => {
          observer.error(error);
        }
      );
    });
  }

  getAps(time, id, reason): Observable<any> {
    return Observable.create((observer) => {
      this.api.getAps(time, id, reason).subscribe(
        (data) => {
          observer.next(data);
          observer.complete();
        },
        (error) => {
          observer.error(error);
        }
      );
    });
  }



  getForm(formName: string): Observable<any> {
    return Observable.create((observer) => {
      this.api.getForm(formName).subscribe(
        (data) => {
          if(this.DEBUG)console.log("cp getForm data", data);
          this.storageMnger.set('persistant', 'login_form', data);
          observer.next(data);
          observer.complete();
        },
        (error) => {
          observer.error(error);
        }
      );
    });
  }



  getWaitingRoomAPI(doctorId: string) {
    return Observable.create((observer) => {
      this.api.getWaitingRoomAPI(doctorId).subscribe(
        (data) => {
          observer.next(data);
          observer.complete();
        },
        (error) => {
          observer.error(error);

        }
      )
    });
  }


  bookWaitingRoom(roomToken, docId) {
    return Observable.create((observer) => {
      this.accMngerPatient.getAccessToken().subscribe(
        (key) => {
          this.api.bookWaitingRoom(key, roomToken, docId).subscribe(
            (data) => {
              observer.next(data);
              observer.complete();
            },
            (error) => {
              observer.error(error);

            }
          )
        },
        (error) => {
          observer.error(error);
        }
      );
    });
  }

  joinWaitingRoom(roomToken, eventId, docId, symptoms: string,
    insKKNumber: string,
    insName: string,
    insNumber: string,
    insStatus: string,
    egkF,
    egkB,
    attachments): Observable<any> {
    return Observable.create((observer) => {
      this.accMngerPatient.getAccessToken().subscribe(
        (key) => {
          this.api
            .joinWaitingRoom(
              key, roomToken, eventId, docId,
              symptoms,
              insKKNumber,
              insName,
              insNumber,
              insStatus,
              egkF,
              egkB,
              attachments
            )
            .subscribe(
              (data) => {
                if (this.DEBUG)
                  console.log(this.TAG, "joinWaitingRoom", "data from api", data);
                observer.next(data);
                observer.complete();
              },
              (error) => {
                observer.error(error);
              }
            );
        },
        (error) => {
          observer.error(error);
        }
      );
    });
  }

  checkBlacklist(docID) {
    return Observable.create((observer) => {
      this.accMngerPatient.getAccessToken().subscribe(
        (key) => {
          this.api.checkBlacklist(key, docID).subscribe(
            (data) => {
              observer.next(data);
              observer.complete();
            },
            (error) => {
              observer.error(error);

            }
          )
        },
        (error) => {
          observer.error(error);
        }
      );
    });
  }



  sendContactForm(formData): Observable<any> {
    //console.log("Daten an die API sendContactForm weitergeben:", formData);
    return Observable.create((observer) => {
        this.api.sendContactForm(formData).subscribe(
            (data) => {
                //console.log("Antwort der API:", data);
                observer.next(data);
                observer.complete();
            },
            (error) => {
                console.error("Fehler bei der API-Antwort:", error);
                observer.error(error);
            }
        );
    });
}

    sendPartnerForm(formData): Observable<any> {
    //console.log("Daten an die API sendContactForm weitergeben:", formData);
    return Observable.create((observer) => {
        this.api.sendPartnerForm(formData).subscribe(
            (data) => {
                //console.log("Antwort der API:", data);
                observer.next(data);
                observer.complete();
            },
            (error) => {
                console.error("Fehler bei der API-Antwort:", error);
                observer.error(error);
            }
        );
    });
}

  checkStornoToken(token: String): Observable<any> {
    return Observable.create((observer) => {
      this.api.checkStornoToken(token).subscribe(
        (data) => {
          observer.next(data);
          observer.complete();
        },
        (error) => {
          observer.error(error);
        }
      )
    });
  }

  stornoApp(uid: String): Observable<any> {
    return Observable.create((observer) => {
      this.api.stornoApp(uid).subscribe(
        (data) => {
          observer.next(data);
          observer.complete();
        },
        (error) => {
          observer.error(error);
        }
      )
    });
  }

  removeSavedCalendar() {
    this.storageMnger.remove("persistent", "savedCal");
  }

  setSavedCalendar(calId) {
    this.setData("persistent", "savedCal", +calId);
    this.storageMnger.set("persistent", "savedCal", +calId);
  }

  setUserMainCalendar(calId) {
    this.setData("persistent", "mainCal", +calId);
    this.storageMnger.set("persistent", "mainCal", +calId);
  }

  getUserMainCalendar(): Observable<any> {
    return Observable.create((observer) => {
      this.storageMnger.getFromStorage("persistent", "mainCal").subscribe((data) => {
        if (data != null) {
          observer.next(data);
          this.setData("persistent", "mainCal", data);
        } else {
          observer.next(false);
        }
      });
    });
  }

  setUserId(userId) {
    this.setData("persistent", "userId", +userId);
    this.storageMnger.set("persistent", "userId", +userId);
  }

  getUserId(): Observable<any> {
    return Observable.create((observer) => {
      this.storageMnger.getFromStorage("persistent", "userId").subscribe((data) => {
        if (data != null) {
          observer.next(data);
          this.setData("persistent", "userId", data);
        } else {
          observer.next(false);
        }
      });
    });
  }

  setSelectedLanguage(lang) {
    this.storageMnger.set("persistent", "selectedLang", lang);
  }

  getSelectedLanguage(): Observable<any> {
    return Observable.create((observer) => {
      this.storageMnger.getFromStorage('persistent', 'selectedLang').subscribe((data) => {
        if (this.DEBUG) {
          console.log("selectedLang", data);
        }
        observer.next(data);
        observer.complete();
      },
        (error) => {
          observer.error(error);
        });
    })
  }

  getPluginSettings(docid): Observable<any> {
    return Observable.create((observer) => {
      this.api.getPluginSettings(docid).subscribe(
        (data) => {
          observer.next(data);
          observer.complete();
        },
        (error) => {
          observer.error(error);
        }
      );
    });
  }

  getCategorySpecs(): Observable<any> {
    return Observable.create((observer) => {
      this.api.getCategorySpecs().subscribe(
        (data) => {
          observer.next(data);
          observer.complete();
        },
        (error) => {
          observer.error(error);
        }
      );
    });
  }

  cancelGroupEvent(eventId: string, symptoms: string): Observable<any> {
    if (this.DEBUG) console.log(this.TAG, "cancelEvent", eventId, symptoms);
    return Observable.create((observer) => {
      this.accMngerPatient.getAccessToken().subscribe(
        (key) => {
          this.api.cancelGroupEvent(key, eventId, symptoms).subscribe(
            (data) => {
              if (this.DEBUG)
                console.log(this.TAG, "cancelEvent", "data from api", data);
              this.notiService.clearNotification(eventId);
              observer.next(data);
              observer.complete();
            },
            (error) => {
              observer.error(error);
            }
          );
        },
        (error) => {
          observer.error(error);
        }
      );
    });
  }

  checkReasonCode(reason,code): Observable<any> {
    return Observable.create((observer) => {
      this.api.checkReasonCode(reason,code).subscribe(
        (data) => {
          observer.next(data);
          observer.complete();
        },
        (error) => {
          observer.error(error);
        }
      );
    });
  }

  disableBMP(uid:string): Observable<any> {
    return Observable.create((observer) => {
      this.accMngerPatient.getAccessToken().subscribe(
        (key) => {
          this.api.disableBMP(key, uid).subscribe(
            (data) => {
              observer.next(data);
              observer.complete();
            },
            (error) => {
              observer.error(error);
            }
          );
        },
        (error) => {
          observer.error(error);
        }
      );
    });
  }

  deleteBMP(uid:string): Observable<any> {
    return Observable.create((observer) => {
      this.accMngerPatient.getAccessToken().subscribe(
        (key) => {
          this.api.deleteBMP(key, uid).subscribe(
            (data) => {
              observer.next(data);
              observer.complete();
            },
            (error) => {
              observer.error(error);
            }
          );
        },
        (error) => {
          observer.error(error);
        }
      );
    });
  }

  activateBMP(uid:string): Observable<any> {
    return Observable.create((observer) => {
      this.accMngerPatient.getAccessToken().subscribe(
        (key) => {
          this.api.activateBMP(key, uid).subscribe(
            (data) => {
              observer.next(data);
              observer.complete();
            },
            (error) => {
              observer.error(error);
            }
          );
        },
        (error) => {
          observer.error(error);
        }
      );
    });
  }

  shareActiveBMP(): Observable<any> {
    return Observable.create((observer) => {
      this.accMngerPatient.getAccessToken().subscribe(
        (key) => {
          this.api.shareActiveBMP(key).subscribe(
            (data) => {
              observer.next(data);
              observer.complete();
            },
            (error) => {
              observer.error(error);
            }
          );
        },
        (error) => {
          observer.error(error);
        }
      );
    });
  }

  getDoctorFormByUId(formId): Observable<any> {
    return Observable.create((observer) => {
      this.api.getDoctorFormByUId(formId).subscribe(
        (data) => {
          observer.next(data);
          observer.complete();
        },
        (error) => {
          observer.error(error);
        }
      );
    });
  }

  sendDocForm(formData, loggedIn, docId): Observable<any> {
    return Observable.create((observer) => {
      if(loggedIn){
        this.accMngerPatient.getAccessToken().subscribe(
          (key) => {
            this.api.sendDocForm(key, formData, docId).subscribe(
              (data) => {
                if (this.DEBUG)
                  console.log(this.TAG, "sendDocForm", "data from api", data);
                observer.next(data);
                observer.complete();
              },
              (error) => {
                observer.error(error);
              }
            );
          },
          (error) => {
            observer.error(error);
          }
        );
      }else{
        this.api.sendDocForm("",formData,docId).subscribe(
          (data) => {
            observer.next(data);
            observer.complete();
          },
          (error) => {
            observer.error(error);
          }
        );
      }
    });
  }

  checkFormular(id): Observable<any> {
    return Observable.create((observer) => {
      this.api.checkFormular(id).subscribe(
        (data) => {
          observer.next(data);
          observer.complete();
        },
        (error) => {
          observer.error(error);
        }
      );
    });
  }

  finishSendDocForm(formId, srId, type, loggedIn): Observable<any> {
    return Observable.create((observer) => {
      if(loggedIn){
        this.accMngerPatient.getAccessToken().subscribe(
          (key) => {
            this.api.finishSendDocForm(key, formId, srId, type).subscribe(
              (data) => {
                if (this.DEBUG)
                  console.log(this.TAG, "sendDocForm", "data from api", data);
                observer.next(data);
                observer.complete();
              },
              (error) => {
                observer.error(error);
              }
            );
          },
          (error) => {
            observer.error(error);
          }
        );
      }else{
        this.api.finishSendDocForm("", formId, srId, type).subscribe(
          (data) => {
            observer.next(data);
            observer.complete();
          },
          (error) => {
            observer.error(error);
          }
        );
      }
    });
  }

  checkDoctorForm(formId, docId): Observable<any> {
    return Observable.create((observer) => {
      this.api.checkDoctorForm(formId, docId).subscribe(
        (data) => {
          observer.next(data);
          observer.complete();
        },(error) => {
          observer.error(error);
        }
      );
    });
  }


  getAllEmployees(): Observable<Employee[]> {
    //console.log('Fetching employees...');

    return this.api.getEmployees().pipe(
      tap(employees => {
        console.log('Received employees:', employees);
      }),
      catchError(error => {
        console.error('Error fetching employees:', error);
        return throwError(() => new Error('Failed to fetch employees'));
      })
    );
  }


  getNews(): Observable<News[]> {
    if(this.DEBUG)console.log('Fetching news...');

    return this.api.getNews().pipe(
      tap(news => {
        if(this.DEBUG)console.log('Received news:',news);
      }),
      catchError(error => {
        console.error('Error fetching news:', error);
        return throwError(() => new Error('Failed to fetch news'));
      })
    );
  }


  getOpenPositions(position: string): Observable<newEmployee<{ designation: number; position: string }>[]> {
    return this.api.getOpenPositions().pipe(
      tap(response => {
        if (this.DEBUG) {
            console.log(' API Response:', response);
        }
    }),
      map((response: Array<{
        id: string;
        designation: number;
        position: string;
        job: string;
        profile: string;
        tasks: string;
        benefits: string;
        description: string;
      }>) => {
        if(this.DEBUG) console.log('Data before mapping:', response);

        const mappedData = response.map(item => {
          return new newEmployee<{ designation: number; position: string }>({
            id: item.id || '',  // Ensure 'id' is correctly mapped
            designation: item.designation || 0,  // Ensure 'designation' is correctly mapped
            position: item.position || '',  // Ensure 'position' is correctly mapped
            job: item.job || '',  // Include 'job' property
            profile: item.profile || '',  // Include 'profile' property
            tasks: item.tasks || '',  // Include 'tasks' property
            benefits: item.benefits || '',
            description: item.description || '',  // Include 'description' property
            data: {  // Provide the 'data' object with 'designation' and 'position'
              designation: item.designation,
              position: item.position
            }
          });
        });

        if(this.DEBUG) console.log('Mapped Data:', mappedData);
        return mappedData;
      }),
      catchError((error: HttpErrorResponse) => {
        console.error('Error fetching employees:', error.message);
        console.error('Status:', error.status);
        console.error('Status Text:', error.statusText);
        console.error('URL:', error.url);

        return throwError(() => new Error('Failed to fetch employees'));
      })
    );
  }

  getExternalDocInfo(id): Observable<any> {
    return Observable.create((observer) => {
      this.api.getExternalDocInfo(id).subscribe(
        (data) => {
          observer.next(data);
          observer.complete();

          this.setData("doc", id, data);
          this.storageMnger.set("doc", id, JSON.stringify(data));
        },(error) => {
          observer.error(error);
        }
      );
    });
  }

  getAllChainsOfDoctor(docId): Observable<any> {
    return Observable.create((observer) => {
      this.api.getAllChainsOfDoctor(docId).subscribe(
        (data) => {
          observer.next(data);
          observer.complete();
        },(error) => {
          observer.error(error);
        }
      );
    });
  }

  getChainDetail(chainId): Observable<any> {
    return Observable.create((observer) => {
      this.api.getChainDetail(chainId).subscribe(
        (data) => {
          observer.next(data);
          observer.complete();
        },(error) => {
          observer.error(error);
        }
      );
    });
  }

    checkIfPatientDataIsComplete(email: string): Observable<boolean> {
    return new Observable((observer) => {
      console.log('Prüfung, ob Patientendaten vollständig sind für:', email);
  
      this.accMngerPatient.getAccessToken().subscribe(
        (accessToken) => {
          if (accessToken !== null) {
            if (this.DEBUG)  console.log('Zugriffstoken erfolgreich erhalten:', accessToken);
  
            this.api.checkPatientDataComplete(email, accessToken).subscribe(
              (response: any) => {
                // Logge die Antwort der API
               if (this.DEBUG) console.log('Antwort von der API:', response);
  
                // Zeige explizit an, was die API zurückgibt
                console.log('Wert, den die API übergibt:', response);  // Protokolliere den exakten Wert von `response`
  
                // Überprüfe, ob die Antwort der API ein Objekt mit der Eigenschaft "complete" enthält
                if (response && typeof response.complete === 'boolean') {
                  if (this.DEBUG) console.log('API gibt einen boolean-Wert zurück:', response.complete);
                  observer.next(response.complete);
                  observer.complete();
                } else {
                  if (this.DEBUG) console.error('Unerwarteter Wert der API-Antwort:', response);
                  if (this.DEBUG) observer.error('Unerwarteter Wert der API-Antwort.');
                }
              },
              (error) => {
                console.error('Fehler beim Prüfen der Patientendaten:', error);
                observer.error('Fehler beim Prüfen der Patientendaten.');
              }
            );
          } else {
            console.error('Kein Zugriffstoken vorhanden.');
            observer.error('Kein Zugriffstoken vorhanden.');
          }
        },
        (error) => {
          console.error('Fehler beim Abrufen des Zugriffstokens:', error);
          observer.error('Fehler beim Abrufen des Zugriffstokens.');
        }
      );
    });
  }

  updatePatient(
  data: {
    address: string | null,
    housenr: string | null,
    zip: string | null,
    city: string | null,
   
  }
): Observable<any> {
  return new Observable((observer) => {
    // AccessToken holen
    this.accMngerPatient.getAccessToken().subscribe(
      (accessToken) => {
        // Optional: Logging
        console.log("updatePatient → Payload an Content Provider API:", data);

        // API-Aufruf nur mit den Patientendaten
        this.api.updatePatient(data, accessToken).subscribe(
          (response) => {
            observer.next(response);  // Erfolgreich weitergeben
            observer.complete();      // Stream schließen
          },
          (error) => {
            observer.error(error);    // Fehler weitergeben
          }
        );
      },
      (error) => {
        observer.error(error);      // Fehler beim Token holen
      }
    );
  });
}

  checkOpenFieldsByDoctorId(docId: number): Observable<any> {
    return new Observable((observer) => {
      // Zugriffstoken holen
      this.accMngerPatient.getAccessToken().subscribe(
        (accessToken) => {
          // 👉 Hier loggen wir die docId
          if (this.DEBUG)  console.log(this.TAG, "checkOpenFieldsByDoctorId", "docId übergeben an API:", docId);
  
          // API-Aufruf mit dem Zugriffstoken
          this.api.checkPatientFieldsByDoctorId(docId, accessToken).subscribe(
            (data) => {
              if (this.DEBUG) {
                if (this.DEBUG)  console.log(this.TAG, "checkOpenFieldsByDoctorId", "data from api", data);
              }
              observer.next(data);     // Erfolgreiches Ergebnis zurückgeben
              observer.complete();     // Stream beenden
            },
            (error) => {
              observer.error(error);   // Fehler an Observer weitergeben
            }
          );
        },
        (error) => {
          observer.error(error);       // Fehler beim Abrufen des Tokens
        }
      );
    });
  }

  getTrainings(): Observable<any> {
    return new Observable((observer) => {
      this.api.getTrainings().subscribe(
        (data) => {
          if (this.DEBUG)  console.log(this.TAG, "getSchulungen", "data from api", data);
          observer.next(data);
          observer.complete();
        },
        (error) => {
          observer.error(error);
        }
      );
    });
  }

  registerTraining(data): Observable<any> {
    return new Observable((observer) => {
      this.api.registerTraining(data).subscribe(
        (data) => {
          if (this.DEBUG)  console.log(this.TAG, "registerTraining", "data from api", data);
          observer.next(data);
          observer.complete();
        },
        (error) => {
          observer.error(error);
        }
      );
    });
  }

  doctorDetail(id: string, lat, lon): Observable<DoctorDetail> {
    return new Observable((observer) => {
      this.api.doctorDetail(id, lat, lon).subscribe(
        (data) => {
          if (this.DEBUG)  console.log(this.TAG, "doctorDetail", "data from api", data);
          observer.next(data);
          observer.complete();
        },
        (error) => {
          observer.error(error);
        }
      );
    });
  }

  getPatientEventById(id): Observable<PatientEvent> {
    return new Observable((observer) => {
      this.accMngerPatient.getAccessToken().subscribe(
        (accessToken) => {
          this.api.getPatientEventById(accessToken, id).subscribe(
            (data) => {
              if (this.DEBUG)  console.log(this.TAG, "doctorDetail", "data from api", data);
              observer.next(data);
              observer.complete();
            },
            (error) => {
              observer.error(error);
            });
        },
        (error) => {
          observer.error(error);
        }
      );
    });
  }
  
  getNewSearchResults(params, force = false) {
    if (this.DEBUG) console.log(this.TAG, "getSearchResults", params, force);

    this.storageMnger.set("persistent", "last_spec", params.spec);
    this.storageMnger.set("persistent", "last_specName", params.specName);
    this.storageMnger.set("persistent", "last_zip", params.zip);
    this.storageMnger.set("persistent", "last_rad", params.rad);
    this.storageMnger.set("persistent", "last_ins", params.ins);

    const specID = params.specID ? Number(params.specID) : 0;
    const search = params.search || '';
    const lat = params.lat || 0;
    const long = params.long || 0;
    const limit = params.limit || 20;
    const offset = params.offset || 0;
    return this.api.searchDoctorsNew(search, specID, lat, long, limit, offset);
  }

  getPatientDashboardData(): Observable<PatientDashboardData[]> {
    return Observable.create((observer) => {
      this.accMngerPatient.getAccessToken().subscribe(
        (key) => {
          this.api.getPatientDashboardData(key).subscribe(
            (data) => {
              observer.next(data);
              observer.complete();
            },
            (error) => {
              observer.error(error);
            }
          );
        },
        (error) => {
          observer.error(error);
        });
    });
  }

  getFaqs(): Observable<any> {
    return Observable.create(observer => {
      this.api.getFaqs().subscribe(data => {
        observer.next(data);
        observer.complete();
      }, error => {
        observer.error(error);
      });
    });
  }

  getPatinetFavDocRequest(): Observable<any[]> {
    return Observable.create((observer) => {
      this.accMngerPatient.getAccessToken().subscribe(
        (key) => {
          this.api.getPatinetFavDocRequest(key).subscribe(
            (data) => {
              observer.next(data);
              observer.complete();
            },
            (error) => {
              observer.error(error);
            }
          );
        },
        (error) => {
          observer.error(error);
        });
    });
  }

  postTenYearsRegistration(payload: any): Observable<any> {
    
    return this.api.postTenYearsRegistration(payload);
  }

  checkPartyRegestration(email: string): Observable<{ exists: boolean }> {
    return this.api.checkPartyRegestration(email);
  }
  

  checkDoctorFormularVersion(formId, docId): Observable<any> {
    return Observable.create((observer) => {
      this.api.checkDoctorFormularVersion(formId, docId).subscribe(
        (data) => {
          observer.next(data);
          observer.complete();
        },(error) => {
          observer.error(error);
        }
      );
    });
  }

  getDoctorNewFormByUId(formId): Observable<any> {
    return Observable.create((observer) => {
      this.api.getDoctorNewFormByUId(formId).subscribe(
        (data) => {
          observer.next(data);
          observer.complete();
        },
        (error) => {
          observer.error(error);
        }
      );
    });
  }

  saveFormPatientDraft(payload): Observable<PatientDashboardData[]> {
    return Observable.create((observer) => {
      this.accMngerPatient.getAccessToken().subscribe(
        (key) => {
          this.api.saveFormPatientDraft(key, payload).subscribe(
            (data) => {
              observer.next(data);
              observer.complete();
            },
            (error) => {
              observer.error(error);
            }
          );
        },
        (error) => {
          observer.error(error);
        });
    });
  }

  getPatientFormDraft(formId): Observable<any[]> {
    return Observable.create((observer) => {
      this.accMngerPatient.getAccessToken().subscribe(
        (key) => {
          this.api.getPatientFormDraft(key, formId).subscribe(
            (data) => {
              observer.next(data);
              observer.complete();
            },
            (error) => {
              observer.error(error);
            }
          );
        },
        (error) => {
          observer.error(error);
        });
    });
  }

  sendNewFormPatient(payload, loggedIn, docId): Observable<PatientDashboardData[]> {
    return Observable.create((observer) => {
      if (loggedIn) {
        this.accMngerPatient.getAccessToken().subscribe(
          (key) => {
            this.api.sendNewFormPatient(key, payload, docId).subscribe(
              (data) => {
                observer.next(data);
                observer.complete();
              },
              (error) => {
                observer.error(error);
              }
            );
          },
          (error) => {
            observer.error(error);
          });
        }
        else{
          this.api.sendNewFormPatient("", payload, docId).subscribe(
            (data) => {
              observer.next(data);
              observer.complete();
            },
            (error) => observer.error(error)
          );
        }
    });
  }

  sendFormPdfViaEmail(payload): Observable<any> {
    return Observable.create((observer) => {
      this.api.sendFormPdfViaEmail(payload).subscribe(
        (data) => {
          observer.next(data);
          observer.complete();
        },
        (error) => {
          observer.error(error);
        }
      );
    });
  }
  
  deletePatientFormDraft(formId): Observable<any[]> {
    return Observable.create((observer) => {
      this.accMngerPatient.getAccessToken().subscribe(
        (key) => {
          this.api.deletePatientFormDraft(key, formId).subscribe(
            (data) => {
              observer.next(data);
              observer.complete();
            },
            (error) => {
              observer.error(error);
            }
          );
        },
        (error) => {
          observer.error(error);
        });
    });
  }
}  

